import apiService from '../apiService'

const apiPath = '/reprintpolicy'

export const reprintController = (configService) => {
  const service = apiService(configService)
  return {
    getReprintPolicy: (params) => {
      return service.post({
        url: `${apiPath}/get_reprint_policy`,
        body: params,
      })
    },
  }
}
